import { Controller } from "@hotwired/stimulus";

// Toggles the enrollment-transfer drawer between its review state and the
// "add a decline reason" state without a server round trip. Both the body
// panels and their matching footer button groups are swapped together.
export default class extends Controller {
  static targets = ["reviewBody", "declineBody", "reviewFooter", "declineFooter"];

  declare readonly reviewBodyTarget: HTMLElement;
  declare readonly declineBodyTarget: HTMLElement;
  declare readonly reviewFooterTarget: HTMLElement;
  declare readonly declineFooterTarget: HTMLElement;

  showDecline(event: Event) {
    event.preventDefault();
    this.toggle(true);
    this.declineBodyTarget.querySelector("textarea")?.focus();
  }

  showReview(event: Event) {
    event.preventDefault();
    this.toggle(false);
  }

  private toggle(declining: boolean) {
    this.reviewBodyTarget.classList.toggle("hidden", declining);
    this.reviewFooterTarget.classList.toggle("hidden", declining);
    this.declineBodyTarget.classList.toggle("hidden", !declining);
    this.declineFooterTarget.classList.toggle("hidden", !declining);
  }
}
